export default {
  namespaced: true,
  state: {
    list: [],
    videoList: [],
    roomVideoList: [],
    roomPageNum: 1,
    roomPageSize: 10,
    roomIsHasNext: true,
    roomCurrentIndex: 0,
    roomStatus: 2
  },
  mutations: {
    updateList (state, list) {
      state.list = list
    },
    updateVideoList (state, list) {
      state.videoList = list
    },
    concatVideoList (state, list = []) {
      state.list = state.list.concat(list)
    },
    updateRoomVideoList (state, list) {
      state.roomVideoList = list
    },
    concatRoomVideoList (state, list = []) {
      state.roomVideoList = state.roomVideoList.concat(list)
    },
    updateRoomPageNum (state, val) {
      state.roomPageNum = val
    },
    updateRoomPageSize (state, val) {
      state.roomPageSize = val
    },
    updateRoomIsHasNext (state, val) {
      state.roomIsHasNext = val
    },
    changeRoomCurrentIndex (state, val) {
      state.roomCurrentIndex += val
    },
    resetRoomCurrentIndex (state, val) {
      state.roomCurrentIndex = val
    },
    updateRoomStatus (state, val) {
      state.roomStatus = val
    }
  }
}
